<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item,index)  in levelList" :key="item.path" v-if="item.meta.title">
        <span v-if="item.redirect==='noredirect'||index==levelList.length-1" class="no-redirect">{{item.meta.title}}</span>
        <router-link v-else :to="item.redirect||item.path">{{item.meta.title}}</router-link>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
export default {
  created() {
    this.getBreadcrumb()
  },
  data() {
    return {
      levelList: null
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.name)
      const first = matched[0]
      if (first && first.name !== 'home' && this.$store.getters.hasDashboard) {
        matched = [{ path: '/home', meta: { title: '首页' }}].concat(matched)
      }
      this.levelList = matched
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  .app-breadcrumb.el-breadcrumb {
    display: flex;
    align-items: center;
    max-width: 60vw;
    overflow: hidden;
    margin-left: 0;
    font-size: 13px;
    line-height: 1;
    white-space: nowrap;

    .el-breadcrumb__item {
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .el-breadcrumb__inner {
      color: #8b9a90;
      font-weight: 500;
    }

    .el-breadcrumb__item:last-child .el-breadcrumb__inner {
      color: #2f4938;
      font-weight: 650;
    }

    .el-breadcrumb__separator {
      margin: 0 10px;
      color: #c2cdc4;
    }

    .no-redirect {
      color: #2f4938;
      font-weight: 650;
      cursor: text;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue